<template>
  <div class="self_membership_card_box">
    <div class="self_mcb_level_box">
      <!--會員等級圖-->
      <div
        class="self_mcb_level_img"
        :style="`height:${window_.m_card_img_h}px`"
      >

        <div class="self_mcb_img_div">
          <van-image
            :src="info_obj.data.levelImgUrl ? info_obj.data.levelImgUrl : info_obj.data.brandImgUrl"
            class="self_mcb_img"
            radius="20px"
          >
            <template v-slot:loading>
              <van-loading
                type="spinner"
                size="20"
              />
            </template>
            <template v-slot:error>
              <van-image
                class="errorImg"
                :src="require('../assets/icon/default.png')"
              />
            </template>
          </van-image>
        </div>
        <!--二維碼圓點-->
        <div class="self_mcb_level_radius">
          <!--qrcodeShow = true-->
          <div @click="getQrcode">
            <img src="../assets/qrcode.png" />
          </div>
        </div>
      </div>
      <!-- 會員信息 -->
      <div class="self_mcb_level_content">
        <div class="name self_color">{{ info_obj.data.levelName1 }}</div>
        <div class="time">
          <span v-if="info_obj.data3.menberUpgradeDate">{{ getDate(info_obj.data3.menberUpgradeDate) }}</span>
          <span v-if="info_obj.data3.menberUpgradeDate && info_obj.data3.endDate">-</span>
          <span v-if="info_obj.data3.endDate">{{ getDate(info_obj.data3.endDate) }}</span>
        </div>
      </div>
    </div>
    <!--會員等級-->
    <div class="self_cell-level-box">
      <!-- 舊等級 -->
      <div class="self_cell-level">
        <img
          src="../assets/huiyuan.png"
          alt
        />
      </div>
      <!-- 進度條 -->
      <div class="self_cell-progress">
        <!-- 當前值 -->
        <van-progress
          color="#c9af7c"
          pivot-color="#c9af7c"
          :show-pivot="true"
          :percentage="(info_obj.data1.nowPrice / info_obj.data3.countPrice) * 100 ? ((info_obj.data1.nowPrice / info_obj.data3.countPrice) * 100 > 100 ? 100 :(info_obj.data1.nowPrice / info_obj.data3.countPrice) * 100) : 0"
          :pivot-text="String(info_obj.data1.nowPrice)"
          stroke-width="5"
          style="height: 6px;"
        />
      </div>
      <!-- 新等級 -->
      <div class="self_cell-level">
        <img
          src="../assets/huiyuan2.png"
          alt
        />
      </div>
    </div>
    <!-- 比值 -->
    <div
      class="self_cell-rate"
      v-text="info_obj.data1.nowPrice + '/' + info_obj.data3.countPrice"
    ></div>
    <!-- 積分 優惠券 -->
    <div class="self_mcb_integral_coupon">
      <div
        class="item"
        @click="goIntegral"
      >
        <div class="title">
          <img
            class="self_bg_color"
            src="../assets/jifen.png"
          />
          <span>{{ window_c['There are 2'] }}</span>
        </div>
        <div class="content"><span class="self_color">{{info_obj.data.consumePoints}}</span>{{ window_c['points'] }}</div>
      </div>
      <div
        class="item"
        @click="goCoupon"
      >
        <div class="title">
          <img
            class="self_bg_color"
            src="../assets/youhuiquan.png"
          />
          <span>{{ window_c['There are 1'] }}</span>
        </div>
        <div class="content"><span class="self_color">{{info_obj.data.couponCount}}</span>{{ window_c['coupons'] }}</div>
      </div>
    </div>

    <!--二維碼彈窗-->
    <div
      v-show="qrcodeShow"
      class="self_membership_qrcode_mark"
      @click="qrcodeShow = false"
      style="z-index:101;"
    >
      <div class="self_membership_qrcode_box">
        <div class="self_membership_qrcode">
          <div
            id="qrcode"
            ref="qrcode"
          ></div>
        </div>
        <img
          class="self_membership_hide"
          src="../assets/icon/icon_close.png"
        />
      </div>
    </div>

  </div>
</template>
<style scoped>
.self_membership_card_box {
  padding: 10px;
  background-color: #fff;
}

.self_mcb_level_box {
}

.self_mcb_level_img {
  width: 100%;
  height: 190px;
  border-radius: 20px;
  position: relative;
}

.self_mcb_img_div,
.self_mcb_img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}

.self_mcb_level_radius {
  position: absolute;
  width: 54px;
  height: 54px;
  background: #fff;
  left: calc(50% - 27px);
  bottom: -27px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

.self_mcb_level_radius div {
  width: 46px;
  height: 46px;
  background: #000;
  border-radius: 50%;
  margin: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.self_mcb_level_radius div img {
  width: 27px;
  height: 27px;
}

.self_mcb_level_content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
}

.self_mcb_level_content .name {
  font-size: 18px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #056384;
}

.self_mcb_level_content .time {
  font-size: 12px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #a3a2a2;
}

.self_cell-level-box {
  display: flex;
  /* align-items: flex-start; */
  align-items: center;
}

.self_cell-progress {
  flex: 1;
  margin-top: 9px;
}

.self_cell-rate {
  font-size: 10px;
  color: #666666;
  text-align: right;
  margin-bottom: 10px;
  margin-right: 20px;
}

.self_cell-level {
  text-align: center;
  display: flex;
  align-items: center;
}

.self_cell-level img {
  width: 20px;
}

/**/
.self_mcb_integral_coupon {
  display: flex;
  justify-content: space-between;
}

.self_mcb_integral_coupon .item {
  width: calc(50% - 5px);
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(1, 1, 1, 0.2);
  border-radius: 8px;
  padding: 10px 0;
}

.self_mcb_integral_coupon .item .title {
  display: flex;
  align-items: center;
  justify-content: center;
}

.self_mcb_integral_coupon .item .title img {
  width: 25px;
  height: 25px;
}

.self_mcb_integral_coupon .item .title span {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #7b7b7b;
}

.self_mcb_integral_coupon .item .content {
  padding: 0;
  text-align: center;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #7b7b7b;
  margin-top: 10px;
}

.self_membership_qrcode_mark {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.self_membership_qrcode_box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.self_membership_qrcode {
  width: 250px;
  height: 250px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}
.self_membership_hide {
  width: 50px;
  height: 50px;
  margin-top: 10px;
}

.errorImg {
  height: 100%;
}
</style>
<script>
import lang_ from '@/js/locales';
import QRCode from 'qrcodejs2';
import util from '@/js/util';
export default {
  name: 'membershipCardOne',
  data () {
    return {
      value: 0,
      qr: null,
      window_: {
        m_card_img_w: 0,
        m_card_img_h: 0,
      },
      window_c: {
        'There are 1': '優惠券',
        coupons: '張',
        'There are 2': '積分',
        points: '分',
        Loading: '加載中...'
      },
      qrcodeShow: false
    }
  },
  methods: {
    init_window () {
      let J = util.getWindowInner();
      let w = J.w;
      this.window_.m_card_img_w = w - 20; //20 表示 左右邊距之和
      this.window_.m_card_img_h = (w - 20) / 1.81; // 1.81 會員卡圖片 比
    },
    getDate (t) {
      try {
        if (t) {
          let d = new Date(t);
          return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        }
        return '';
      } catch (e) {
        return '';
      }
    },
    init_lang () {
      var window_c = this.window_c;
      window_c['There are 1'] = lang_.t('There are 1');
      window_c['coupons'] = lang_.t('coupons');
      window_c['There are 2'] = lang_.t('There are 2');
      window_c['points'] = lang_.t('points');
      window_c['Loading'] = lang_.t('Loading');
    },
    getQrcode () {
      if (!this.qr) {
        let that = this;
        this.qr = new QRCode('qrcode', {
          width: 230,
          height: 230,
          text: that.qrcodeContent
        })
      }
      this.qrcodeShow = true
    },
    goIntegral () {
      sessionStorage.setItem('consumePoints', this.info_obj.data.consumePoints)
      // 积分
      this.$router.push({
        name: "integral",
        params: {
          arg: this.$route.params.arg
        }
      });
    },
    goCoupon () {
      // 优惠卷
      this.$router.push({
        name: "my_coupon",
        params: {
          arg: this.$route.params.arg
        }
      });
    }
  },
  mounted () {
    this.init_window();
    this.init_lang();
    console.log(this.qrcodeImg);
  },
  props: ["info_obj", "qrcodeContent"]
}
</script>



// WEBPACK FOOTER //
// src/components/membershipCardOne.vue